import { DateField, TextField, useDynamicConfig } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { getMaximumSubdomainLength } from "./baseApplicationFormValidate";

export const BaseApplicationDataFields: FC = () => {
	const { t } = useTranslation();
	const { baseDomain } = useDynamicConfig();

	return (
		<>
			<TextField
				label={t("Subdomain")}
				name="subdomain"
				maxChars={getMaximumSubdomainLength(baseDomain)}
				required={true}
			/>
			<TextField label={t("Project number")} name="projectNumber" required={true} />
			<DateField label={t("Setup date")} name="setupDate" required={true} />
			<DateField label={t("Deletion date")} name="deletionDate" required={true} />
		</>
	);
};
